package br.com.texeratx.boardgametimeapp.ui.screens.clan

import br.com.texeratx.boardgametimeapp.data.model.clan.ClanDTO

data class ClanUiState(
    val isLoading: Boolean = false,
    val error: String? = null,

    val clan: ClanDTO? = null,
    val localImageBytes: ByteArray? = null,
    val localImageMimeType: String? = null,
    val selectedImageName: String? = null,
    val isUploadingImage: Boolean = false,

    val isOwner: Boolean = false,
    val isAdmin: Boolean = false,

    val isEditing: Boolean = false,
    val nameInput: String = "",
    val requireApprovalInput: Boolean = false,

    val isSaving: Boolean = false,
    val isLeaving: Boolean = false,

    val isChangePasswordDialogOpen: Boolean = false,
    val currentPasswordInput: String = "",
    val newPasswordInput: String = "",
    val confirmNewPasswordInput: String = "",
    val isChangingPassword: Boolean = false,
    val changePasswordError: String? = null,
)
